/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import Vue from 'vue'
import axios from 'axios';
//  import store from '@/store/store.js'
import 'element-ui/lib/theme-chalk/index.css'
import { Notification } from 'element-ui';
//  import bus from '@/utils/bus.js'
// 引用axios，并设置基础URL为后端服务api地址
axios.defaults.baseURL = '/api'

// 请求超时时间
axios.defaults.timeout = 30000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json';

// 请求拦截器
axios.interceptors.request.use(
    config => {
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        //const token = store.state.login.loginToken;
        const token = localStorage.getItem("x-auth-token");
        let ip = sessionStorage.getItem("IP");
        var asd = { "e": "2" };
        config.headers['ip-address'] = ip;
        //config.headers['Host'] = "http://localhost:8080";
        if (token) {  // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
            if (config.data) {
                if (config.data.hasOwnProperty("funId")) {

                    var funId = config.data["funId"];
                    Vue.delete(config.data, 'funId');
                    var staff_id = sessionStorage.getItem("staffId");
                    var seqId = parseInt(sessionStorage.getItem("seqId")) + 1;
                    //呼叫流水id
                    var callId = store.getters['chd/getCallInfo'].CallGUID;
                    if (callId == undefined || callId == '') {
                        callId = "0";
                    }
                    sessionStorage.setItem("seqId", seqId);
                    var msg = staff_id + "-" + funId + "-" + seqId + "-" + callId;
                    config.headers['logInfo'] = encodeURI(msg);
                }
            }

        }
        return config;
    },
    error => {
        return Promise.error(error);
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            if (response.headers["x-auth-token"] != undefined && response.headers["x-auth-token"] != "") {
                store.commit("login/setLoginToken", response.headers["x-auth-token"]);
                localStorage.setItem("x-auth-token", response.headers["x-auth-token"]);
                sessionStorage.setItem("x-auth-token", response.headers["x-auth-token"])
            }
            return Promise.resolve(response);
        } else {
            if (response.status == 203) {
                console.log(response);
            }
            return Promise.reject(response);
        }

    },
    // 服务器状态码不是200的情况
    error => {
        if (error.response.status) {
            switch (error.response.status) {
                case 409:
                    Notification.error({ title: '系统提示', message: '用户已登录，请勿重复登录！', position: 'bottom-right' });
                    break;
                case 400:
                    Notification.error({ title: '系统提示', message: '错误请求！', position: 'bottom-right' });
                    break;
                case 401:     // 401: 未登录
                    Notification.error({ title: '系统提示', message: '未登录，请先登录！', position: 'bottom-right' });
                    router.replace({ path: '/loginMain', query: { redirect: router.currentRoute.fullPath } });
                    break;
                case 403:    // 403 token过期
                    Notification.error({ title: '系统提示', message: '用户已登录，请勿重复登录！', position: 'bottom-right' });
                    // 清除token
                    store.commit("login/setLoginToken", "");
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
                    setTimeout(() => { router.replace({ path: '/loginMain', query: { redirect: router.currentRoute.fullPath } }); }, 1000);
                    break;
                case 404: // 404请求不存在
                    Notification.error({ title: '系统提示', message: '网络请求不存在！', position: 'bottom-right' });
                    break;
                case 500:
                    Notification.error({ title: '系统提示', message: '服务器端出错', position: 'bottom-right' });
                    break;
                default: // 其他错误，直接抛出错误提示
                    Notification.error({ title: '系统提示', message: error.response.data.message, position: 'bottom-right' });
            }
            return Promise.reject(error.response);
        }
    }
);
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function uploadPost(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
export default {
    get,
    post,
    uploadPost
}
